
  import React from "react"
  import Component from "/Users/Matthew/git/evolutionofcannabis/src/layouts/index.jsx"
  import data from "/Users/Matthew/git/evolutionofcannabis/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js